import { useQuery } from "@tanstack/react-query";
import { useSupabaseClient } from "@/lib/supabase";
import { queryKeys, type UsageRange } from "@/lib/api/queryKeys";
import { cachePolicies } from "@/lib/api/cache-policies";
import { getUsageEvents } from "../api/getUsageEvents";
import { aggregateUsage, type UsageSummary } from "../lib/aggregate";

export function useUsageSummary(range: UsageRange) {
  const { client, isReady } = useSupabaseClient();
  return useQuery<UsageSummary>({
    queryKey: [...queryKeys.uso.summary({ range }), isReady],
    queryFn: async () => {
      const rows = await getUsageEvents(client, range);
      return aggregateUsage(rows);
    },
    enabled: isReady,
    staleTime: cachePolicies.uso.summary.staleTime,
    gcTime: cachePolicies.uso.summary.gcTime,
  });
}
